import React, { useState } from 'react';

const SERVICES = [
    { num:'01', title:'Property Sales',        desc:'Expert guidance through every stage of buying or selling property in the UAE — from initial valuation to final handover.',               tags:['Residential','Commercial','Off-plan'] },
    { num:'02', title:'Property Leasing',      desc:'Comprehensive leasing solutions connecting quality tenants with premium properties across Dubai and the UAE.',                           tags:['Short-term','Long-term','Corporate'] },
    { num:'03', title:'Property Management',   desc:'Full-service management for landlords — maximising occupancy, rental income, and long-term asset value.',                               tags:['Maintenance','Tenant Relations','Reporting'] },
    { num:'04', title:'Investment Advisory',   desc:'Strategic investment advice grounded in market intelligence, helping clients identify high-yield opportunities in the UAE.',            tags:['Portfolio','ROI Analysis','Market Reports'] },
    { num:'05', title:'Valuation Services',    desc:'Accurate, professional property valuations for sales, rentals, insurance, and financial planning purposes.',                           tags:['RERA Compliant','Certified','Detailed Reports'] },
    { num:'06', title:'Legal & Documentation', desc:'Streamlined documentation support ensuring every transaction is legally sound and fully compliant with UAE regulations.',              tags:['Contracts','Due Diligence','NOC Processing'] },
];

const Services: React.FC = () => {
    // ✅ Fixed: was [setHov] — missing the state variable
    const [, setHov] = useState<number | null>(null);

    return (
        <>
            <style>{`
        /* ── Section ── */
        .svc-section {
          background: var(--sec-alt);
          padding: 7rem 0;
          position: relative;
          transition: background 0.4s;
        }
        .svc-section::before {
          content: ''; position: absolute; top: 0; left: 0; right: 0; height: 1px;
          background: linear-gradient(90deg, transparent, var(--border-t), transparent);
        }
        .svc-inner { max-width: 1280px; margin: 0 auto; padding: 0 5rem; }

        /* ── Header ── */
        .svc-head { text-align: center; margin-bottom: 4rem; }
        .svc-head .sec-label { justify-content: center; }
        .svc-head .sec-label::before { display: none; }

        /* ── Grid ── */
        .svc-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1px;
          background: var(--border);
        }

        /* ── Card ── */
        .svc-card {
          background: var(--surface);
          padding: 2.8rem 2.4rem;
          position: relative; overflow: hidden; cursor: default;
          transition: background 0.35s, transform 0.25s;
        }
        .svc-card:hover { background: var(--surface2); }
        .svc-card::after {
          content: ''; position: absolute; bottom: 0; left: 0; right: 0;
          height: 2px; background: var(--teal);
          transform: scaleX(0); transform-origin: left;
          transition: transform 0.4s var(--ease);
        }
        .svc-card:hover::after { transform: scaleX(1); }

        /* Number — decorative, intentionally large & faint */
        .svc-num {
          font-family: var(--ff-h);
          font-size: 3.2rem; font-weight: 300; line-height: 1;
          color: var(--border-t);
          margin-bottom: 1.4rem;
          transition: color 0.3s;
        }
        .svc-card:hover .svc-num { color: var(--teal-pale2); }

        /* Title */
        .svc-title {
          font-family: var(--ff-ui);
          font-size: 0.8rem;           /* fixed: was 0.72 */
          font-weight: 600;
          letter-spacing: 0.14em; text-transform: uppercase;
          color: var(--ink);
          margin-bottom: 1rem;
          transition: color 0.3s;
        }
        .svc-card:hover .svc-title { color: var(--teal); }

        /* Description */
        .svc-desc {
          font-family: var(--ff-b);
          font-size: 0.95rem;          /* fixed: was 0.78 — too small */
          font-weight: 400;            /* fixed: was 300 — too thin */
          line-height: 1.85;
          color: var(--ink2);
          margin-bottom: 1.4rem;
        }

        /* Tags */
        .svc-tags { display: flex; flex-wrap: wrap; gap: 6px; }
        .svc-tag {
          font-family: var(--ff-b);
          font-size: 0.72rem;          /* fixed: was 0.67 */
          font-weight: 400;
          letter-spacing: 0.05em;
          color: var(--teal);
          border: 1px solid var(--border-t);
          padding: 4px 11px;
          border-radius: var(--r);
          background: var(--teal-pale);
          transition: background 0.3s;
        }
        .svc-card:hover .svc-tag { background: var(--teal-pale2); }

        /* Arrow */
        .svc-arrow {
          position: absolute; top: 1.6rem; right: 1.6rem;
          font-size: 1.1rem; color: var(--border2);
          transition: color 0.3s, transform 0.3s;
        }
        .svc-card:hover .svc-arrow { color: var(--teal); transform: translate(3px, -3px); }

        /* ── Responsive ── */
        @media (max-width: 900px) {
          .svc-inner { padding: 0 2rem; }
          .svc-grid  { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 600px) {
          .svc-grid { grid-template-columns: 1fr; }
          .svc-desc { font-size: 0.92rem; }
        }
      `}</style>

            <section id="services" className="svc-section">
                <div className="svc-inner">

                    <div className="svc-head">
                        <p className="sec-label">What We Offer</p>
                        <h2 className="sec-h2">
                            Comprehensive Real Estate <em>Services</em>
                        </h2>
                    </div>

                    <div className="svc-grid">
                        {SERVICES.map((s, i) => (
                            <div
                                key={s.num}
                                className="svc-card"
                                onMouseEnter={() => setHov(i)}
                                onMouseLeave={() => setHov(null)}
                            >
                                <div className="svc-num">{s.num}</div>
                                <p className="svc-title">{s.title}</p>
                                <p className="svc-desc">{s.desc}</p>
                                <div className="svc-tags">
                                    {s.tags.map(t => (
                                        <span key={t} className="svc-tag">{t}</span>
                                    ))}
                                </div>
                                <span className="svc-arrow">↗</span>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
        </>
    );
};

export default Services;